<div class="collection-container">
    @for (item of inputValue; track trackByIndex(i, item); let i = $index) {
        <div
            [@fadeIn]="!!item.__created"
            [class.dim]="fade === i"
            [class.single]="singleLine"
            [class.card]="!singleLine"
            [class.collapsed]="!singleLine && collapsable && !expanded.has(i) && selectedTask && item.id !== selectedTask"
            [class.highlight]="selectedTask && item.id === selectedTask"
            class="collection-rows"
        >
            <hr class="separator" />
            @if (!singleLine) {
                <div
                    [id]="item.id"
                    class="card-header d-flex py-1 px-1 px-lg-1 d-print-none align-items-center"
                    (click)="$event.stopPropagation(); toggleExpanded(i)"
                >
                    @if (childrenValid.includes(i) && !itemForm.touched) {
                        <i class="text-danger fa fa-triangle-exclamation me-2"></i>
                    }
                    <div class="complete-toggle">
                        @if (inputValue[i].complete) {
                            <button
                                class="btn btn-success btn-sm me-2 px-1"
                                [disabled]="view.vars.disabled"
                                (click)="$event.stopPropagation(); toggleComplete(i)"
                                ngbTooltip="Mark Task Incomplete"
                            >
                                <i class="fa fa-fw fa-square-check fa-regular"></i>
                            </button>
                        }
                        @if (!inputValue[i].complete) {
                            <button
                                class="btn btn-light btn-sm me-2 px-1"
                                [disabled]="view.vars.disabled"
                                (click)="$event.stopPropagation(); toggleComplete(i)"
                                ngbTooltip="Mark Task Complete"
                            >
                                <i class="fa fa-fw fa-square fa-regular"></i>
                            </button>
                        }
                    </div>
                    @if (inputValue[i].allocatedUser) {
                        <ngxh6-usericon class="me-2" size="small" [user]="inputValue[i].allocatedUser"></ngxh6-usericon>
                    }
                    <p class="m-0 text-nowrap">
                        @if (item?.type?.string) {
                            <strong class="me-2">{{ item.type?.string }}:</strong>
                        }
                        {{ item[descriptionField] }}
                    </p>
                    <div class="flex-shrink-0 ms-auto d-flex align-items-center">
                        <ng-container [ngTemplateOutlet]="actions"></ng-container>
                    </div>
                </div>
            }
            <form
                [class.small]="small"
                #itemForm="ngForm"
                ngForm
                (click)="!!(collapsable && !expanded.has(i) && toggleExpanded(i)); (null)"
                [@collapse]="{ value: expanded.has(i) || (selectedTask && item.id === selectedTask) || !collapsable, params: { collapsed_height: 0 } }"
            >
                @if (isCompleteOffline(item.id) || !offlineService.isConnected) {
                    @if (completeTasks.has(item.id)) {
                        <div class="alert alert-success">
                            <div class="offline btn btn-sm btn-success ms-2 float-right" (click)="completeOffline(item.id)">Edit</div>
                            Task completed offline. Data will update on next sync.
                        </div>
                    }
                    @if (!completeTasks.has(item.id) && !offlineService.isConnected) {
                        <div class="alert alert-warning">
                            @if (canCompleteOffline(item)) {
                                <div class="offline btn btn-sm btn-primary ms-2 float-right" (click)="completeOffline(item.id)">Complete Offline</div>
                            }
                            You're currently offline. Functionality is limited.
                        </div>
                    }
                }
                @if (!singleValue) {
                    <div [ngClass]="!singleLine ? 'card-body p-2 p-lg-3' : 'flex-grow-1'">
                        <sf-form
                            #sfFormComponent
                            [view]="$any(view.children)[i] || view?.vars?.prototype"
                            name="value"
                            [(ngModel)]="inputValue[i]"
                            [renderAll]="true"
                            (ngModelChange)="onInputChange()"
                            [formClasses]="'collection-row row'"
                            [horizontal]="horizontal"
                            [wide]="wide"
                        ></sf-form>
                    </div>
                }
                @if (singleValue) {
                    <div class="row flex-grow-1">
                        <sf-widget
                            rowClasses="col-12"
                            [view]="$any(view.children)[i] || view?.vars?.prototype"
                            name="value"
                            [(ngModel)]="inputValue[i]"
                            (ngModelChange)="onInputChange()"
                            [horizontal]="false"
                        ></sf-widget>
                    </div>
                }
                @if (singleLine) {
                    <div class="d-flex flex-column">
                        <label class="form-label invisible">.</label>
                        <ng-container [ngTemplateOutlet]="actions"></ng-container>
                    </div>
                }
            </form>
            <ng-template #actions>
                @if (item.id) {
                    <div class="btn btn-sm btn-gray" (click)="$event.stopPropagation(); modalService.history(item.id)" [class.d-none]="singleLine">
                        <i class="fa fa-clock-rotate-left"></i>
                    </div>
                }
                @if (collapsable) {
                    <div class="btn btn-sm ms-2 btn-gray expand" (click)="$event.stopPropagation(); toggleExpanded(i)" [class.d-none]="singleLine">
                        <i class="fa" [class.fa-expand]="!expanded.has(i)" [class.fa-compress]="expanded.has(i)"></i>
                    </div>
                }
                @if (view?.vars?.allow_delete || item?.__created) {
                    <div
                        class="btn ms-2 btn-danger collection-remove"
                        (click)="$event.stopPropagation(); removeItem(i)"
                        (mouseover)="fade = i"
                        (mouseleave)="fade = null"
                        [class.btn-sm]="!singleLine"
                    >
                        <i class="fa fa-trash"></i>
                    </div>
                }
            </ng-template>
        </div>
    }
</div>

@if (view?.vars?.allow_add) {
    <div class="d-flex">
        <button type="button" class="btn btn-gray mt-1 mb-0" (click)="addItem()"><i class="fa fa-plus"></i> {{ view?.vars?.attr?.add_label || 'Add' }}</button>
    </div>
}
